const data = [
  // --- SOFTWARE & WEB TRACK ---
  {
    id: 1,
    name: "nft-marketplace",
    filter: "software",
    description: "JavaScript/React/React-Native",
    link: "https://lucky-tooth-1581.on.fleek.co/",
    repo: "https://github.com/Derimarg/nft_marketplace_site",
  },
  {
    id: 2,
    name: "code-command",
    filter: "software",
    description: "React/Heroku/MongoDB",
    link: "https://code-command-team.herokuapp.com/",
    repo: "https://github.com/Derimarg/code-command",
  },
  {
    id: 3,
    name: "forge-project",
    filter: "software",
    description: "HTML/CSS/JS/Node/Express/MySQL/Handlebars",
    link: "https://forge-team.herokuapp.com/splash",
    repo: "https://github.com/Derimarg/Forge",
  },
  {
    id: 4,
    name: "git-it-done",
    filter: "software",
    description: "HTML/Bootstrap/JavaScript",
    link: "https://derimarg.github.io/git-it-done/",
    repo: "https://github.com/Derimarg/git-it-done",
  },
  {
    id: 5,
    name: "work-day-scheduler",
    filter: "software",
    description: "HTML/CSS/JavaScript",
    link: "https://derimarg.github.io/work-day-scheduler/",
    repo: "https://github.com/Derimarg/work-day-scheduler",
  },
  {
    id: 6,
    name: "run-buddy",
    filter: "software",
    description: "Fitness center web platform for recreational and professional athletes.",
    link: "https://derimarg.github.io/run-buddy/",
    repo: "https://github.com/Derimarg/run-buddy",
  },
  {
    id: 7,
    name: "just-tech-news",
    filter: "software",
    description: "Node/MySQL/Sequelize",
    link: "https://just-tech-news-dapp.herokuapp.com/",
    repo: "https://github.com/Derimarg/just-tech-news",
  },
  {
    id: 8,
    name: "note-taker",
    filter: "software",
    description: "Node/Express/Bootstrap",
    link: "https://my-notes-taker.herokuapp.com/",
    repo: "https://github.com/Derimarg/note-taker",
  },
  {
    id: 9,
    name: "taskmaster-pro",
    filter: "software",
    description: "To Do app that allows users to organize tasks.",
    link: "https://derimarg.github.io/taskmaster-pro/",
    repo: "https://github.com/Derimarg/taskmaster-pro",
  },
  {
    id: 10,
    name: "weather-dashboard",
    filter: "software",
    description: "Search for cities to get current weather and 5-day forecasts.",
    link: "https://derimarg.github.io/weather-dashboard/",
    repo: "https://github.com/Derimarg/weather-dashboard",
  },
  {
    id: 11,
    name: "tech-blog",
    filter: "software",
    description: "CMS-style blog site about tech news and articles.",
    link: "https://dg-tech-blog.herokuapp.com/",
    repo: "https://github.com/Derimarg/tech-blog",
  },
  {
    id: 12,
    name: "password-generator",
    filter: "software",
    description: "Generates random secure passwords based on custom criteria.",
    link: "https://derimarg.github.io/password-generator/",
    repo: "https://github.com/Derimarg/password-generator",
  },

  // --- ELECTRICAL & SYSTEMS TRACK ---
  // {
  //   id: 13,
  //   name: "power-grid-simulation",
  //   filter: "electrical",
  //   description: "MATLAB/Simulink model analyzing power distribution, load flow, and system dynamics.",
  //   link: "https://github.com/Derimarg",
  //   repo: "https://github.com/Derimarg",
  // },

  // --- MECHANICAL & AUTOMATION TRACK ---
  // {
  //   id: 14,
  //   name: "thermal-stress-analysis",
  //   filter: "mechanical",
  //   description: "Finite Element Analysis (FEA) and stress distribution modeling for mechanical assemblies.",
  //   link: "https://github.com/Derimarg",
  //   repo: "https://github.com/Derimarg",
  // },
];

export default data;